import { format } from "date-fns"
import { Upload } from "../../../models/Interfaces"
import { Button } from "@mui/material"
import { downloadAttachment } from "../../../misc/download"
import { Icons } from "../../../misc/Icons"
import TruncText from "../../../misc/TruncText"
import { UTCDate } from "@date-fns/utc"

export default function QuestionnaireUploads ({questionnaire}) {
    
    if (!questionnaire.uploads?.length) {
        return <p>There are no attachments for this Questionnaire.</p>
    }
    
    return (
        <div style={{display: "grid", gridTemplateColumns: "auto 145px 90px", gap: "10px", alignItems: "center", margin: "5px 0"}}>
            {questionnaire.uploads.map((upload: Upload, i) => (
                <>
                    <TruncText text={upload.displayName} />
                    
                    
                    <span>{format(new UTCDate(upload.updatedAt), "yyyy-MM-dd hh:mm:ss")}</span>
                    
                    <Button
                        color="success"
                        variant="contained"
                        className="btn btn-xs" 
                        onClick={() => downloadAttachment(upload.uid)}>
                        <Icons.Download /> Download
                    </Button>
                </>
            ))}
        </div>
    )
}